import Vue from 'vue';
import Router from 'vue-router';

import TrackingOverviewPage from '../tracking/TrackingOverviewPage';
import ChartPage from '../charts/ChartPage';
import TrainingPage from '../training/TrainingPage';
import QuizPage from '../quiz/QuizPage';
import TrainingPageDone from '../training/TrainingPageDone';
import PreviewPage from '../tracking/PreviewPage';
import TrackingDetailPage from '../tracking/TrackingDetailPage';
import TrackingPage from '../tracking/TrackingPage';
import ProfilePage from '../profile/ProfilePage';
import LoginPage from '../login/LoginPage';
import MotivationPage from '../motivation/MotivationPage';
import ForgotPasswordPage from '../login/ForgotPasswordPage';
import ChangePasswordPage from '../login/ChangePasswordPage';
import WelcomePage from '../welcome/WelcomePage';
import DeleteUserPage from '../admin/DeleteUserPage.vue';
import UserOverviewPage from '../user/UserOverviewPage.vue';

Vue.use(Router);

export const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: {
        name: 'welcome'
      }
    },
    {
      path: '/login',
      name: 'login',
      component: LoginPage
    },
    {
      path: '/login/forgotpassword',
      name: 'forgotpassword',
      component: ForgotPasswordPage
    },
    {
      path: '/changepassword/:token',
      name: 'changepassword',
      component: ChangePasswordPage
    },
    {
      path: '/welcome',
      name: 'welcome',
      component: WelcomePage
    },
    {
      path: '/tracking/overview',
      name: 'overview',
      component: TrackingOverviewPage
    },
    {
      path: '/motivation',
      name: 'motivation',
      component: MotivationPage
    },
    {
      path: '/course/:id',
      name: 'training',
      component: TrainingPage
    },
    {
      path: '/quiz/:id',
      name: 'quiz',
      component: QuizPage
    },
    {
      path: '/course/:id/done',
      name: 'course-done',
      component: TrainingPageDone
    },
    {
      path: '/profile',
      name: 'profile',
      component: ProfilePage
    },
    {
      path: '/tracking/preview',
      name: 'preview',
      component: PreviewPage
    },
    {
      path: '/tracking/detail',
      name: 'detail',
      component: TrackingDetailPage
    },
    {
      path: '/tracking',
      name: 'tracking',
      component: TrackingPage
    },
    {
      path: '/charts',
      name: 'charts',
      component: ChartPage
    },
    {
      path: '/deleteuser',
      name: 'deleteuser',
      component: DeleteUserPage
    },
    {
      path: '/users',
      name: 'users',
      component: UserOverviewPage
    },
    {
      path: '*',
      redirect: '/login'
    }
  ]
});

router.beforeEach((to, from, next) => {
  const publicPages = ['/login', '/login/forgotpassword'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('user');
  if (
    authRequired &&
    !loggedIn &&
    !to.path.match(/\/changepassword\/[a-z0-9]/g)
  ) {
    localStorage.setItem('redirectUrl', to.path);
    return next('/login');
  }

  next();
});



// WEBPACK FOOTER //
// ./src/_helpers/router.js